import UserInfo from "../../interfaces/UserInfo";

export const formatConversationTitle = (participants: UserInfo[]): string => {
    if (!participants || participants.length === 0) {
        return "Unknown conversation";
    }

    const nameList = participants.map(p => {
        const firstName = p.firstName || p.displayName || "Unknown";
        const lastNameInitial = p.lastName ? ` ${p.lastName.charAt(0)}.` : "";
        return `${firstName}${lastNameInitial}`;
    });

    if (nameList.length > 2) {
        return `${nameList.slice(0, 2).join(', ')} and ${nameList.length - 2} others`;
    }

    return nameList.join(' & ');
};
